
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { Alert, Box, Button, Container, styled, Typography } from '@mui/material';

import { CartContent } from '@frontend/features/cart/components/CartContent';
import { useCart } from '@frontend/features/cart/components/CartContext';
import { CartCrossSellBanner } from '@frontend/features/cart/components/CartCrossSellBanner';
import { CartSummaryAndPay } from '@frontend/features/cart/components/CartSummaryAndPay';
import { useRuteroCartBookingAuthority } from '@frontend/features/cart/ruteroCartBookingAuthority';
import { Link } from '@frontend/features/common/components/Link';
import { routes } from '../routes';

const StyledBox = styled(Box)(({ theme }) => ({
  flex: 1,
  gap: theme.spacing(5),
  display: 'flex',
  flexDirection: 'column'
}));

export const Cart = () => {
  const { state } = useCart();
  const { t } = useTranslation();
  const ruteroBookingAuthority = useRuteroCartBookingAuthority(state?.items || []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);
  
  return (
    <Container maxWidth="xl">
      <Box display="flex" flexDirection="column" p={[0, 5]} gap={5} >
        <Typography variant="h6"> {t('cart.title')}</Typography>
        {!state ? (
          <Alert
            severity="info"
            action={
              <Link to={routes.hotels.home} underline="none">
                <Button color="inherit" size="small">
                  {t('cart.legacy.goToHotels')}
                </Button>
              </Link>
            }
          >
            {t('cart.legacy.directAccess')}
          </Alert>
        ) : <Box display="flex" gap={3} alignItems="flex-start">
          <StyledBox>
            <CartContent p={0} ruteroBookingAuthority={ruteroBookingAuthority}/>
            <CartCrossSellBanner />
          </StyledBox>
          <CartSummaryAndPay ruteroBookingAuthority={ruteroBookingAuthority} />
        </Box>}
      </Box>
    </Container>
  );
};
